import { ISeatInfo } from "@/domain/entities/book";
import { IBookDetailInfo, IBookInfo } from "./book.types";
import {
  BookIntervalCode,
  BookStatusName,
  LineTypeCode,
  LineTypeName,
  PGCode,
} from "@/types";

export class BookInfo implements IBookInfo {
  readonly id: string;
  readonly bookDetailId: string;
  readonly bookNum: string;
  readonly turnId: string;
  readonly lineNum: string;
  readonly routeName: string;
  readonly lineTypeCode: LineTypeCode;
  readonly lineTypeName: LineTypeName;
  readonly bookSuccess: boolean;
  readonly bookFailedReason: string;
  readonly bookStatus: BookStatusName;
  readonly bookDateTime: string;
  readonly bookCancelAmount?: number;
  readonly bookCancelDateTime?: string;
  readonly bookCancelEndDateTime?: string;
  readonly boardDate: string;
  readonly boardingDates?: IBookDetailInfo[];
  readonly realBoardDate?: string;
  readonly firstStopTime: string;
  readonly getOnStopName: string;
  readonly getOnStopId: string;
  readonly getOffStopName: string;
  readonly getOffStopId: string;
  readonly departureTime: string;
  readonly arrivalTime: string;
  readonly seatNo: string;
  readonly floorNo: number;
  readonly isPastBook: boolean;
  readonly bookAmount: number;
  readonly pgCode: PGCode;
  readonly bookIntervalCode: BookIntervalCode;
  readonly seatAssignYn: boolean;
  readonly allocUid: string;
  readonly carNo?: string;
  readonly vendorName?: string;
  seatsInfo?: Array<ISeatInfo[][]>;
  remainAmount?: number;
  cancelableAmount?: number;
  cancelableYn?: boolean;
  penaltyAmount?: number;

  constructor(data: IBookInfo) {
    this.id = data.id;
    this.bookDetailId = data.bookDetailId;
    this.bookNum = data.bookNum;
    this.turnId = data.turnId;
    this.lineNum = data.lineNum;
    this.routeName = data.routeName;
    this.lineTypeCode = data.lineTypeCode;
    this.lineTypeName = data.lineTypeName;
    this.bookSuccess = data.bookSuccess;
    this.bookFailedReason = data.bookFailedReason;
    this.bookStatus = data.bookStatus;
    this.bookDateTime = data.bookDateTime;
    this.bookCancelAmount = data.bookCancelAmount;
    this.bookCancelDateTime = data.bookCancelDateTime;
    this.bookCancelEndDateTime = data.bookCancelEndDateTime;
    this.boardDate = data.boardDate;
    this.boardingDates = data.boardingDates;
    this.realBoardDate = data.realBoardDate;
    this.firstStopTime = data.firstStopTime;
    this.getOnStopName = data.getOnStopName;
    this.getOnStopId = data.getOnStopId;
    this.getOffStopName = data.getOffStopName;
    this.getOffStopId = data.getOffStopId;
    this.departureTime = data.departureTime;
    this.arrivalTime = data.arrivalTime;
    this.seatNo = data.seatNo;
    this.floorNo = data.floorNo;
    this.isPastBook = data.isPastBook;
    this.bookAmount = data.bookAmount;
    this.pgCode = data.pgCode;
    this.bookIntervalCode = data.bookIntervalCode;
    this.seatAssignYn = data.seatAssignYn;
    this.allocUid = data.allocUid;
    this.carNo = data.carNo;
    this.vendorName = data.vendorName;
    this.seatsInfo = data.seatsInfo;
    this.remainAmount = data.remainAmount;
    this.cancelableAmount = data.cancelableAmount;
    this.cancelableYn = data.cancelableYn;
    this.penaltyAmount = data.penaltyAmount;
  }
}
